// output filter factory for programmatic access
import { IMarketingCloudUser, ResourceOutputFilterMiddleware } from '@ads/iam-library';
import { getCachedEnforcer } from './getCachedEnforcer';

// eslint-disable-next-line import/prefer-default-export
export async function createOutputFilter(user: IMarketingCloudUser): Promise<ResourceOutputFilterMiddleware> {
    const enforcer = await getCachedEnforcer(user);
    return new ResourceOutputFilterMiddleware(enforcer);
}
